import {
  sendGetRequest
} from "@/helper/requests";
import coherent_urls from "@/urls/coherent";


const state = {
  coherent_values: {},
}

const getters = {
  getCoherentValues: (state) => (coherent) => {
    /**
     * Возвращает когерентные значения для указанного типа
     */
    return state.coherent_values
  },
  isCoherentLoaded: state => (coherent) => {
    /**
     * Проверяет, загружены ли когерентные значения для указанного типа
     */
    return state.hasOwnProperty(coherent)
  }
}

const mutations = {
  setCoherentValues: (state, {coherent, data}) => {
    /**
     * Сохраняет когерентные значения в состоянии
     */
    state.coherent_values[coherent] = data
  },
}

const actions = {
  // Main choice
  loadCoherentValues: ({commit, getters}, {coherent, finalizer, catcher, force}={finalizer: () => {}, catcher: () => {}, force: false}) => {
    /**
     * Загружает когерентные значения для указанного типа
     * @param {Function} commit - Функция для вызова мутаций
     * @param {Function} getters - Геттеры Vuex
     * @param {string} coherent - Имя когерентного типа для загрузки
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     * @param {boolean} force - Принудительная загрузка, даже если данные уже есть
     */
    if (force || !getters.isCoherentLoaded(coherent)) {
      sendGetRequest(
        coherent_urls.COHERENT(coherent),
        (data) => {
          commit('setCoherentValues', {coherent, data})
          finalizer(data)
        },
        catcher
      )
    }

  },

}


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}


